import React from 'react';
export const Footer = () => {
  return <footer className="border-t border-gray-200 pt-6 text-sm text-gray-600" data-id="element-203">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-204">
        Over Amee de Bruijn
      </h2>

      <div className="flex items-start mb-6" data-id="element-205">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-24 h-24 rounded-full object-cover mr-4 flex-shrink-0" data-id="element-206" />
        <div data-id="element-207">
          <p className="mb-4 leading-relaxed" data-id="element-208">
            Als hondengedragsdeskundige is het welzijn van een hond — maar ook
            van zijn mens — voor mij het allerbelangrijkste.
          </p>
          <p className="mb-4 leading-relaxed" data-id="element-209">
            Daarom werk ik uitsluitend met methodes die vrij zijn van dwang,
            pijn, angst en straf. Vertrouwen, veiligheid, wederzijds respect en
            communicatie staan centraal in alles wat ik doe.
          </p>
        </div>
      </div>

      <p className="mb-4 leading-relaxed" data-id="element-210">
        In 2017 behaalde ik mijn diploma als Natural Dog Trainer &
        Gedragsconsultant niveau 5 bij Calming Signs in Koningslust. Sindsdien
        heb ik meer dan 15.000 baasjes en hun honden mogen helpen bij het
        versterken van hun band.
      </p>

      <p className="mb-6 leading-relaxed italic text-blue-800" data-id="element-211">
        "Goed en liefdevol communiceren kun je leren. Het is de sleutel tot een
        leuk en probleemloos leven samen met je hond. Ik kan niet wachten om
        deze kennis ook met jou te delen."
      </p>

      <p className="text-right mb-6" data-id="element-212">— Amee de Bruijn</p>

      <div className="text-xs border-t border-gray-200 pt-4 pb-2" data-id="element-213">
        <p className="text-gray-500 mb-3" data-id="element-214">
          Meta Advertising Disclaimer: Deze website maakt gebruik van Meta Pixel
          voor advertentiedoeleinden. Dit betekent dat informatie over uw bezoek
          aan deze website wordt gedeeld met Meta (Facebook) om gerichte
          advertenties te kunnen tonen. Door gebruik te maken van deze website
          gaat u akkoord met het gebruik van cookies en vergelijkbare
          technologieën voor analytische en advertentiedoeleinden. Deze pagina
          is een advertorial voor Stressless Dogs. Stressless Dogs is een
          onafhankelijk bedrijf en is op geen enkele wijze verbonden aan of
          onderdeel van Meta (voorheen Facebook). Deze advertentie wordt getoond
          via het Meta advertentieplatform, maar Meta is niet verantwoordelijk
          voor de inhoud of diensten aangeboden door Stressless Dogs.
        </p>
        <p className="text-center text-gray-500" data-id="element-215">
          © 2025 Stressless Dogs — www.stresslessdogs.nl
        </p>
      </div>
    </footer>;
};